/** Indique si l'on peut stocker cet élément dans un locker. */
export interface IIsiStorable {
}
export interface IIsiDataTransferObject extends IIsiStorable  {
}
export abstract class IsiDataTransferObject implements IIsiDataTransferObject {

    constructor(data?: IIsiDataTransferObject) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data?: IIsiDataTransferObject): IsiDataTransferObject {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'IsiDataTransferObject' cannot be instantiated.");
    }

    toJSON(data?: any): any {
        data = typeof data === 'object' ? data : {};

        return data;
    }
}
export interface IIsiDtoUIClientState extends IIsiDataTransferObject  {
    componentsClientState?: { [key: string]: IIsiDtoComponentClientState; };
}
/** Représente l'état d'un composant coté client */
export interface IIsiDtoComponentClientState extends IIsiDataTransferObject  {
    id?: string;
}
export class IsiDtoUIClientState extends IsiDataTransferObject implements IIsiDtoUIClientState {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.Dto.UI.IsiDtoUIClientState, Isilog.IsiFramework.IsiDataTransferObject";
    componentsClientState?: { [key: string]: IIsiDtoComponentClientState; };

    constructor(data?: IIsiDtoUIClientState) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.componentsClientState = _data["componentsClientState"] !== undefined ? _data["componentsClientState"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoUIClientState): IsiDtoUIClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoUIClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["componentsClientState"] = this.componentsClientState !== undefined ? this.componentsClientState : <any>null;
        return data;
    }
}
export interface IIsiDtoComponentV4 extends IIsiDataTransferObject  {
    /** Définit si l'état du composant doit être conservé */
    keepState?: boolean;
    /** Definit le mode d'état : Server ou Client */
    stateMode?: StateModeValue;
    /** Obtient ou définie qui est responsable de la sauvegarde de l'état : le composant lui même ou quelqu'un d'autre */
    saveClientStateResponsible?: SaveClientStateResponsibleValue;
    /** Obtient ou définie si la sauvegarde de l'état client est activée ou non */
    saveClientState?: boolean;
    /** Obtient ou définie si la sauvegarde de l'état client est activée ou non */
    __type?: string;
}
/** Valeurs de mode d'état client */
export enum StateModeValue {
    Server = 0,
    Client = 1,
}
export enum SaveClientStateResponsibleValue {
    Himself = 0,
    Other = 1,
}
export class IsiDtoComponentV4 extends IsiDataTransferObject implements IIsiDtoComponentV4 {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.IsiDtoComponentV4, Isilog.IsiFramework.IsiDataTransferObject";
    /** Définit si l'état du composant doit être conservé */
    keepState?: boolean;
    /** Definit le mode d'état : Server ou Client */
    stateMode?: StateModeValue;
    /** Obtient ou définie qui est responsable de la sauvegarde de l'état : le composant lui même ou quelqu'un d'autre */
    saveClientStateResponsible?: SaveClientStateResponsibleValue;
    /** Obtient ou définie si la sauvegarde de l'état client est activée ou non */
    saveClientState?: boolean;
    /** Obtient ou définie si la sauvegarde de l'état client est activée ou non */
    __type?: string;

    constructor(data?: IIsiDtoComponentV4) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.keepState = _data["keepState"] !== undefined ? _data["keepState"] : false;
            this.stateMode = _data["stateMode"] !== undefined ? _data["stateMode"] : 0;
            this.saveClientStateResponsible = _data["saveClientStateResponsible"] !== undefined ? _data["saveClientStateResponsible"] : 0;
            this.saveClientState = _data["saveClientState"] !== undefined ? _data["saveClientState"] : false;
            this.__type = _data["__type"] !== undefined ? _data["__type"] : "";
        }
    }

    static fromJS(data?: IIsiDtoComponentV4): IsiDtoComponentV4 {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoComponentV4();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["keepState"] = this.keepState !== undefined ? this.keepState : false;
        data["stateMode"] = this.stateMode !== undefined ? this.stateMode : 0;
        data["saveClientStateResponsible"] = this.saveClientStateResponsible !== undefined ? this.saveClientStateResponsible : 0;
        data["saveClientState"] = this.saveClientState !== undefined ? this.saveClientState : false;
        data["__type"] = this.__type !== undefined ? this.__type : "";
        return data;
    }
}
export interface IIsiDtoDateEditor extends IIsiDtoComponentV4  {
    /** attribut contenant l'identifiant utilisé par le robot */
    diagAttributeId?: string;
    /** identifiant utilisé par le robot
  */
    diagnosticId?: string;
    /** Le flag n’est pas impacté par la nouvelle évolution de la limitation des dates. */
    acceptAllDate?: boolean;
    /** Date maximum */
    dateMax?: Date;
    /** Date minimum */
    dateMin?: Date;
    accessKey?: string;
    tabIndex?: number;
    /** Collection de style utilisés directement sur le composant.
Est renvoyé au client sous "cssStyles". */
    cssStyles?: { [key: string]: string; };
    /** Indique si l'on doit outrepasser le DateType et afficher toute la date (date + heure) dans un seul champ. 
Cela est actuellement utilisé pour le mode vintage de l'application.
Est renvoyé au client sous "fullDateInOneField". */
    fullDateInOneField?: boolean;
    /** Indique si le composant est mode recherche
Est renvoyé au client sous "searchMode". */
    searchMode?: boolean;
    /** Classe CSS settée lors d'un hover sur le composant
Est renvoyé au client sous "hoverCssClass". */
    hoverCssClass?: string;
    /** Classe CSS settée lors d'un focus sur le composant
Est renvoyé au client sous "focusCssClass". */
    focusCssClass?: string;
    /** Indique si l'élément est désactivé ou non.
Est renvoyé au client sous "disabled". */
    disabled?: boolean;
    /** Fonction appelée au retour de la validation du calendrier.
Est renvoyé au client sous "buttonClickedFunction". */
    buttonClickedFunction?: string;
    /** Element dans lequel ouvrir le calendrier DateTimePicker
Est renvoyé au client sous "divContainer". */
    divContainer?: string;
    /** Contient le format de stockage de la date selon le produit.
Est utilisé pour la conversion des strings en date via momentjs
Est renvoyé au client sous "fullDateIwsFormat". */
    fullDateIwsFormat?: string;
    /** Contient le format d'affichage de la date
Est utilisé pour la conversion des strings en date via momentjs
Est renvoyé au client sous "dateIwsFormat". */
    dateIwsFormat?: string;
    /** Contiens le type de date.
0 : DateTime
1 : Date
2 : Time
Est renvoyé au client sous "dateType". */
    dateType?: number;
    /** Contiens le mask de saisie du composant.
Est renvoyé au client sous "mask". */
    mask?: string;
    /** Contiens la valeur du composant. */
    value?: string;
}
export class IsiDtoDateEditor extends IsiDtoComponentV4 implements IIsiDtoDateEditor {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.DateEditor.IsiDtoDateEditor, Isilog.IsiFramework.IsiDataTransferObject";
    /** attribut contenant l'identifiant utilisé par le robot */
    diagAttributeId?: string;
    /** identifiant utilisé par le robot
  */
    diagnosticId?: string;
    /** Le flag n’est pas impacté par la nouvelle évolution de la limitation des dates. */
    acceptAllDate?: boolean;
    /** Date maximum */
    dateMax?: Date;
    /** Date minimum */
    dateMin?: Date;
    accessKey?: string;
    tabIndex?: number;
    /** Collection de style utilisés directement sur le composant.
Est renvoyé au client sous "cssStyles". */
    cssStyles?: { [key: string]: string; };
    /** Indique si l'on doit outrepasser le DateType et afficher toute la date (date + heure) dans un seul champ. 
Cela est actuellement utilisé pour le mode vintage de l'application.
Est renvoyé au client sous "fullDateInOneField". */
    fullDateInOneField?: boolean;
    /** Indique si le composant est mode recherche
Est renvoyé au client sous "searchMode". */
    searchMode?: boolean;
    /** Classe CSS settée lors d'un hover sur le composant
Est renvoyé au client sous "hoverCssClass". */
    hoverCssClass?: string;
    /** Classe CSS settée lors d'un focus sur le composant
Est renvoyé au client sous "focusCssClass". */
    focusCssClass?: string;
    /** Indique si l'élément est désactivé ou non.
Est renvoyé au client sous "disabled". */
    disabled?: boolean;
    /** Fonction appelée au retour de la validation du calendrier.
Est renvoyé au client sous "buttonClickedFunction". */
    buttonClickedFunction?: string;
    /** Element dans lequel ouvrir le calendrier DateTimePicker
Est renvoyé au client sous "divContainer". */
    divContainer?: string;
    /** Contient le format de stockage de la date selon le produit.
Est utilisé pour la conversion des strings en date via momentjs
Est renvoyé au client sous "fullDateIwsFormat". */
    fullDateIwsFormat?: string;
    /** Contient le format d'affichage de la date
Est utilisé pour la conversion des strings en date via momentjs
Est renvoyé au client sous "dateIwsFormat". */
    dateIwsFormat?: string;
    /** Contiens le type de date.
0 : DateTime
1 : Date
2 : Time
Est renvoyé au client sous "dateType". */
    dateType?: number;
    /** Contiens le mask de saisie du composant.
Est renvoyé au client sous "mask". */
    mask?: string;
    /** Contiens la valeur du composant. */
    value?: string;

    constructor(data?: IIsiDtoDateEditor) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.diagAttributeId = _data["diagAttributeId"] !== undefined ? _data["diagAttributeId"] : <any>null;
            this.diagnosticId = _data["diagnosticId"] !== undefined ? _data["diagnosticId"] : <any>null;
            this.acceptAllDate = _data["acceptAllDate"] !== undefined ? _data["acceptAllDate"] : false;
            this.dateMax = _data["dateMax"] !== undefined ? _data["dateMax"] : <any>null;
            this.dateMin = _data["dateMin"] !== undefined ? _data["dateMin"] : <any>null;
            this.accessKey = _data["accessKey"] !== undefined ? _data["accessKey"] : <any>null;
            this.tabIndex = _data["tabIndex"] !== undefined ? _data["tabIndex"] : 0;
            this.cssStyles = _data["cssStyles"];
            this.fullDateInOneField = _data["fullDateInOneField"] !== undefined ? _data["fullDateInOneField"] : false;
            this.searchMode = _data["searchMode"] !== undefined ? _data["searchMode"] : false;
            this.hoverCssClass = _data["hoverCssClass"] !== undefined ? _data["hoverCssClass"] : <any>null;
            this.focusCssClass = _data["focusCssClass"] !== undefined ? _data["focusCssClass"] : <any>null;
            this.disabled = _data["disabled"] !== undefined ? _data["disabled"] : false;
            this.buttonClickedFunction = _data["buttonClickedFunction"] !== undefined ? _data["buttonClickedFunction"] : <any>null;
            this.divContainer = _data["divContainer"] !== undefined ? _data["divContainer"] : <any>null;
            this.fullDateIwsFormat = _data["fullDateIwsFormat"] !== undefined ? _data["fullDateIwsFormat"] : <any>null;
            this.dateIwsFormat = _data["dateIwsFormat"] !== undefined ? _data["dateIwsFormat"] : <any>null;
            this.dateType = _data["dateType"] !== undefined ? _data["dateType"] : 0;
            this.mask = _data["mask"] !== undefined ? _data["mask"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoDateEditor): IsiDtoDateEditor {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoDateEditor();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["diagAttributeId"] = this.diagAttributeId !== undefined ? this.diagAttributeId : <any>null;
        data["diagnosticId"] = this.diagnosticId !== undefined ? this.diagnosticId : <any>null;
        data["acceptAllDate"] = this.acceptAllDate !== undefined ? this.acceptAllDate : false;
        data["dateMax"] = this.dateMax !== undefined ? this.dateMax : <any>null;
        data["dateMin"] = this.dateMin !== undefined ? this.dateMin : <any>null;
        data["accessKey"] = this.accessKey !== undefined ? this.accessKey : <any>null;
        data["tabIndex"] = this.tabIndex !== undefined ? this.tabIndex : 0;
        data["cssStyles"] = this.cssStyles !== undefined ? this.cssStyles : <any>null;
        data["fullDateInOneField"] = this.fullDateInOneField !== undefined ? this.fullDateInOneField : false;
        data["searchMode"] = this.searchMode !== undefined ? this.searchMode : false;
        data["hoverCssClass"] = this.hoverCssClass !== undefined ? this.hoverCssClass : <any>null;
        data["focusCssClass"] = this.focusCssClass !== undefined ? this.focusCssClass : <any>null;
        data["disabled"] = this.disabled !== undefined ? this.disabled : false;
        data["buttonClickedFunction"] = this.buttonClickedFunction !== undefined ? this.buttonClickedFunction : <any>null;
        data["divContainer"] = this.divContainer !== undefined ? this.divContainer : <any>null;
        data["fullDateIwsFormat"] = this.fullDateIwsFormat !== undefined ? this.fullDateIwsFormat : <any>null;
        data["dateIwsFormat"] = this.dateIwsFormat !== undefined ? this.dateIwsFormat : <any>null;
        data["dateType"] = this.dateType !== undefined ? this.dateType : 0;
        data["mask"] = this.mask !== undefined ? this.mask : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}
export interface IIsiDtoFormValidateManagerSettings extends IIsiDataTransferObject  {
    /** Regles du controle */
    rules?: IIsiDtoFormValidateManagerRules[];
    /** ID du formulaire */
    formId?: string;
}
export interface IIsiDtoFormValidateManagerRules extends IIsiDataTransferObject  {
    /** Le message a afficher lorsque la rule n'est pas valide */
    msgValidation?: string;
    /** La valeur de clef du critère */
    regexp?: string;
    /** Identifiant du controle */
    ctrlId?: string;
}
export class IsiDtoFormValidateManagerRules extends IsiDataTransferObject implements IIsiDtoFormValidateManagerRules {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.IsiDtoFormValidateManagerRules, Isilog.IsiFramework.IsiDataTransferObject";
    /** Le message a afficher lorsque la rule n'est pas valide */
    msgValidation?: string;
    /** La valeur de clef du critère */
    regexp?: string;
    /** Identifiant du controle */
    ctrlId?: string;

    constructor(data?: IIsiDtoFormValidateManagerRules) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.msgValidation = _data["msgValidation"] !== undefined ? _data["msgValidation"] : <any>null;
            this.regexp = _data["regexp"] !== undefined ? _data["regexp"] : <any>null;
            this.ctrlId = _data["ctrlId"] !== undefined ? _data["ctrlId"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoFormValidateManagerRules): IsiDtoFormValidateManagerRules {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoFormValidateManagerRules();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["msgValidation"] = this.msgValidation !== undefined ? this.msgValidation : <any>null;
        data["regexp"] = this.regexp !== undefined ? this.regexp : <any>null;
        data["ctrlId"] = this.ctrlId !== undefined ? this.ctrlId : <any>null;
        return data;
    }
}
export class IsiDtoFormValidateManagerSettings extends IsiDataTransferObject implements IIsiDtoFormValidateManagerSettings {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.UI.IsiDtoFormValidateManagerSettings, Isilog.IsiFramework.IsiDataTransferObject";
    /** Regles du controle */
    rules?: IsiDtoFormValidateManagerRules[];
    /** ID du formulaire */
    formId?: string;

    constructor(data?: IIsiDtoFormValidateManagerSettings) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.rules = _data["rules"] !== undefined ? _data["rules"] : [];
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoFormValidateManagerSettings): IsiDtoFormValidateManagerSettings {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoFormValidateManagerSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["rules"] = this.rules !== undefined ? this.rules : [];
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        return data;
    }
}
export interface IIsiDtoUI extends IIsiDataTransferObject  {
    currentCulture?: string;
    detectClient?: boolean;
    enableFileDragNDrop?: boolean;
    controller?: IIsiDtoControllerSettings;
    formValidateManagerSettings?: IIsiDtoFormValidateManagerSettings;
    componentManager?: IIsiDtoComponentManagerSettings;
    webpackPublicPath?: string;
    isModeDiag?: boolean;
    confirmLostModif?: number;
    ruptureGrand?: number;
    ruptureMoyen?: number;
    rupturePetit?: number;
    enableMobile?: boolean;
    allowHistoryBack?: boolean;
}
export interface IIsiDtoControllerSettings extends IIsiDataTransferObject  {
    props?: { [key: string]: any; };
    id?: string;
}
/** Configuration du IsiPageController coté client */
export class IsiDtoControllerSettings extends IsiDataTransferObject implements IIsiDtoControllerSettings {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.UI.IsiDtoControllerSettings, Isilog.IsiFramework.IsiDataTransferObject";
    props?: { [key: string]: any; };
    id?: string;

    constructor(data?: IIsiDtoControllerSettings) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.props = _data["props"] !== undefined ? _data["props"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoControllerSettings): IsiDtoControllerSettings {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoControllerSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["props"] = this.props !== undefined ? this.props : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}
export interface IIsiDtoComponentManagerSettings extends IIsiDataTransferObject  {
    props?: { [key: string]: any; };
    id?: string;
}
/** Configuration du IsiComponentManager coté client */
export class IsiDtoComponentManagerSettings extends IsiDataTransferObject implements IIsiDtoComponentManagerSettings {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.UI.IsiDtoComponentManagerSettings, Isilog.IsiFramework.IsiDataTransferObject";
    props?: { [key: string]: any; };
    id?: string;

    constructor(data?: IIsiDtoComponentManagerSettings) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.props = _data["props"] !== undefined ? _data["props"] : <any>null;
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoComponentManagerSettings): IsiDtoComponentManagerSettings {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoComponentManagerSettings();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["props"] = this.props !== undefined ? this.props : <any>null;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}
export class IsiDtoUI extends IsiDataTransferObject implements IIsiDtoUI {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.UI.IsiDtoUI, Isilog.IsiFramework.IsiDataTransferObject";
    currentCulture?: string;
    detectClient?: boolean;
    enableFileDragNDrop?: boolean;
    controller?: IsiDtoControllerSettings;
    formValidateManagerSettings?: IsiDtoFormValidateManagerSettings;
    componentManager?: IsiDtoComponentManagerSettings;
    webpackPublicPath?: string;
    isModeDiag?: boolean;
    confirmLostModif?: number;
    ruptureGrand?: number;
    ruptureMoyen?: number;
    rupturePetit?: number;
    enableMobile?: boolean;
    allowHistoryBack?: boolean;

    constructor(data?: IIsiDtoUI) {
        super(data);
        if (data) {
            this.controller = data.controller && !(<any>data.controller).toJSON ? new IsiDtoControllerSettings(data.controller) : <IsiDtoControllerSettings>this.controller;
            this.formValidateManagerSettings = data.formValidateManagerSettings && !(<any>data.formValidateManagerSettings).toJSON ? new IsiDtoFormValidateManagerSettings(data.formValidateManagerSettings) : <IsiDtoFormValidateManagerSettings>this.formValidateManagerSettings;
            this.componentManager = data.componentManager && !(<any>data.componentManager).toJSON ? new IsiDtoComponentManagerSettings(data.componentManager) : <IsiDtoComponentManagerSettings>this.componentManager;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.currentCulture = _data["currentCulture"] !== undefined ? _data["currentCulture"] : <any>null;
            this.detectClient = _data["detectClient"] !== undefined ? _data["detectClient"] : false;
            this.enableFileDragNDrop = _data["enableFileDragNDrop"] !== undefined ? _data["enableFileDragNDrop"] : false;
            this.controller = _data["controller"] ? IsiDtoControllerSettings.fromJS(_data["controller"]) : <any>null;
            this.formValidateManagerSettings = _data["formValidateManagerSettings"] ? IsiDtoFormValidateManagerSettings.fromJS(_data["formValidateManagerSettings"]) : <any>null;
            this.componentManager = _data["componentManager"] ? IsiDtoComponentManagerSettings.fromJS(_data["componentManager"]) : <any>null;
            this.webpackPublicPath = _data["webpackPublicPath"] !== undefined ? _data["webpackPublicPath"] : <any>null;
            this.isModeDiag = _data["isModeDiag"] !== undefined ? _data["isModeDiag"] : false;
            this.confirmLostModif = _data["confirmLostModif"] !== undefined ? _data["confirmLostModif"] : 0;
            this.ruptureGrand = _data["ruptureGrand"] !== undefined ? _data["ruptureGrand"] : 0;
            this.ruptureMoyen = _data["ruptureMoyen"] !== undefined ? _data["ruptureMoyen"] : 0;
            this.rupturePetit = _data["rupturePetit"] !== undefined ? _data["rupturePetit"] : 0;
            this.enableMobile = _data["enableMobile"] !== undefined ? _data["enableMobile"] : false;
            this.allowHistoryBack = _data["allowHistoryBack"] !== undefined ? _data["allowHistoryBack"] : false;
        }
    }

    static fromJS(data?: IIsiDtoUI): IsiDtoUI {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoUI();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["currentCulture"] = this.currentCulture !== undefined ? this.currentCulture : <any>null;
        data["detectClient"] = this.detectClient !== undefined ? this.detectClient : false;
        data["enableFileDragNDrop"] = this.enableFileDragNDrop !== undefined ? this.enableFileDragNDrop : false;
        data["controller"] = this.controller != null ? (<any>this.controller).toJSON() : <any>null;
        data["formValidateManagerSettings"] = this.formValidateManagerSettings != null ? (<any>this.formValidateManagerSettings).toJSON() : <any>null;
        data["componentManager"] = this.componentManager != null ? (<any>this.componentManager).toJSON() : <any>null;
        data["webpackPublicPath"] = this.webpackPublicPath !== undefined ? this.webpackPublicPath : <any>null;
        data["isModeDiag"] = this.isModeDiag !== undefined ? this.isModeDiag : false;
        data["confirmLostModif"] = this.confirmLostModif !== undefined ? this.confirmLostModif : 0;
        data["ruptureGrand"] = this.ruptureGrand !== undefined ? this.ruptureGrand : 0;
        data["ruptureMoyen"] = this.ruptureMoyen !== undefined ? this.ruptureMoyen : 0;
        data["rupturePetit"] = this.rupturePetit !== undefined ? this.rupturePetit : 0;
        data["enableMobile"] = this.enableMobile !== undefined ? this.enableMobile : false;
        data["allowHistoryBack"] = this.allowHistoryBack !== undefined ? this.allowHistoryBack : false;
        return data;
    }
}
/** Interface lié à l'objet renvoyé dans la réponse d'un HttpHandler
  */
export interface IIsiDtoHttpHandlerRequest extends IIsiDataTransferObject  {
    /** Obtient ou définie la valeur de l'objet contenant les données à renvoyer
  */
    data?: IIsiDataTransferObject;
}
/** Objet renvoyé dans la réponse d'un HttpHandler
  */
export class IsiDtoHttpHandlerRequest extends IsiDataTransferObject implements IIsiDtoHttpHandlerRequest {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.HttpHandlers.IsiDtoHttpHandlerRequest, Isilog.IsiFramework.IsiDataTransferObject";
    /** Obtient ou définie la valeur de l'objet contenant les données à renvoyer
  */
    data?: IIsiDataTransferObject;

    constructor(data?: IIsiDtoHttpHandlerRequest) {
        super(data);
        if (data) {
            this.data = data.data;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.data = _data["data"];
        }
    }

    static fromJS(data?: IIsiDtoHttpHandlerRequest): IsiDtoHttpHandlerRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoHttpHandlerRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["data"] = this.data != null ? (<any>this.data).toJSON() : <any>null;
        return data;
    }
}
export interface IIsiDtoHttpHandlerRequestV3 extends IIsiDtoHttpHandlerRequest  {
    refresh?: boolean;
}
export class IsiDtoHttpHandlerRequestV3 extends IsiDtoHttpHandlerRequest implements IIsiDtoHttpHandlerRequestV3 {
    refresh?: boolean;
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.HttpHandlers.IsiDtoHttpHandlerRequestV3`1, Isilog.IsiFramework.IsiDataTransferObject";

    constructor(data?: IIsiDtoHttpHandlerRequestV3) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.refresh = _data["refresh"] !== undefined ? _data["refresh"] : false;
        }
    }

    static fromJS(data?: IIsiDtoHttpHandlerRequestV3): IsiDtoHttpHandlerRequestV3 {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoHttpHandlerRequestV3();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["refresh"] = this.refresh !== undefined ? this.refresh : false;
        data["$type"] = this.$type;
        return data;
    }
}
/** Interface lié à l'objet renvoyé dans la réponse d'un HttpHandler */
export interface IIsiDtoHttpHandlerRequestV4 extends IIsiDtoHttpHandlerRequestV3  {
    response?: IIsiDtoHttpHandlerResponseV4;
}
/** Interface lié à l'objet renvoyé dans la réponse d'un HttpHandler
  */
export interface IIsiDtoHttpHandlerResponse extends IIsiDataTransferObject  {
    /** Liste des messages d'informations du result */
    informations?: string[];
    /** Obtient ou définit le libellé de l'erreur. */
    error?: IIsiDtoHttpHandlerError;
    /** Obtient ou définie la valeur de l'objet contenant les données à renvoyer
  */
    data?: IIsiDataTransferObject;
    success?: boolean;
}
/** Interface lié à l'objet renvoyé dans la réponse d'un HttpHandler
  */
export interface IIsiDtoHttpHandlerResponseV3 extends IIsiDtoHttpHandlerResponse  {
}
/** Interface lié à l'objet renvoyé dans la réponse d'un HttpHandler
  */
export interface IIsiDtoHttpHandlerResponseV4 extends IIsiDtoHttpHandlerResponseV3  {
}
/** Interface définissant la structure d'une erreur renvoyée par un handler HTTP
  */
export interface IIsiDtoHttpHandlerError extends IIsiDataTransferObject  {
    /** Obtient ou définit le type de l'erreur. */
    errorType?: string;
    /** Obtient ou définit l'id de l'erreur. */
    errorId?: string;
    /** Message détaillant l'erreur */
    errorMessage?: string;
}
/** Interface définissant la structure d'une erreur renvoyée par un handler HTTP */
export class IsiDtoHttpHandlerError extends IsiDataTransferObject implements IIsiDtoHttpHandlerError {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.HttpHandlers.IsiDtoHttpHandlerError, Isilog.IsiFramework.IsiDataTransferObject";
    /** Obtient ou définit le type de l'erreur. */
    errorType?: string;
    /** Obtient ou définit l'id de l'erreur. */
    errorId?: string;
    /** Message détaillant l'erreur */
    errorMessage?: string;

    constructor(data?: IIsiDtoHttpHandlerError) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.errorType = _data["errorType"] !== undefined ? _data["errorType"] : <any>null;
            this.errorId = _data["errorId"] !== undefined ? _data["errorId"] : <any>null;
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoHttpHandlerError): IsiDtoHttpHandlerError {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoHttpHandlerError();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["errorType"] = this.errorType !== undefined ? this.errorType : <any>null;
        data["errorId"] = this.errorId !== undefined ? this.errorId : <any>null;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : <any>null;
        return data;
    }
}
/** Objet renvoyé dans la réponse d'un HttpHandler
  */
export class IsiDtoHttpHandlerResponse extends IsiDataTransferObject implements IIsiDtoHttpHandlerResponse {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.HttpHandlers.IsiDtoHttpHandlerResponse, Isilog.IsiFramework.IsiDataTransferObject";
    /** Liste des messages d'informations du result */
    informations?: string[];
    /** Obtient ou définit le libellé de l'erreur. */
    error?: IsiDtoHttpHandlerError;
    /** Obtient ou définie la valeur de l'objet contenant les données à renvoyer
  */
    data?: IIsiDataTransferObject;
    success?: boolean;

    constructor(data?: IIsiDtoHttpHandlerResponse) {
        super(data);
        if (data) {
            this.error = data.error && !(<any>data.error).toJSON ? new IsiDtoHttpHandlerError(data.error) : <IsiDtoHttpHandlerError>this.error;
            this.data = data.data;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.informations = _data["informations"] !== undefined ? _data["informations"] : [];
            this.error = _data["error"] ? IsiDtoHttpHandlerError.fromJS(_data["error"]) : <any>null;
            this.data = _data["data"];
            this.success = _data["success"] !== undefined ? _data["success"] : false;
        }
    }

    static fromJS(data?: IIsiDtoHttpHandlerResponse): IsiDtoHttpHandlerResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoHttpHandlerResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["informations"] = this.informations !== undefined ? this.informations : [];
        data["error"] = this.error != null ? (<any>this.error).toJSON() : <any>null;
        data["data"] = this.data != null ? (<any>this.data).toJSON() : <any>null;
        data["success"] = this.success !== undefined ? this.success : false;
        return data;
    }
}
/** Objet renvoyé dans la réponse d'un HttpHandler
  */
export class IsiDtoHttpHandlerResponseV3 extends IsiDtoHttpHandlerResponse implements IIsiDtoHttpHandlerResponseV3 {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.HttpHandlers.IsiDtoHttpHandlerResponseV3, Isilog.IsiFramework.IsiDataTransferObject";

    constructor(data?: IIsiDtoHttpHandlerResponseV3) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
        }
    }

    static fromJS(data?: IIsiDtoHttpHandlerResponseV3): IsiDtoHttpHandlerResponseV3 {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoHttpHandlerResponseV3();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        return data;
    }
}
/** Objet renvoyé dans la réponse d'un HttpHandler
  */
export class IsiDtoHttpHandlerResponseV4 extends IsiDtoHttpHandlerResponseV3 implements IIsiDtoHttpHandlerResponseV4 {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.HttpHandlers.IsiDtoHttpHandlerResponseV4, Isilog.IsiFramework.IsiDataTransferObject";

    constructor(data?: IIsiDtoHttpHandlerResponseV4) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
        }
    }

    static fromJS(data?: IIsiDtoHttpHandlerResponseV4): IsiDtoHttpHandlerResponseV4 {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoHttpHandlerResponseV4();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        return data;
    }
}
/** Objet renvoyé dans la réponse d'un HttpHandler */
export class IsiDtoHttpHandlerRequestV4 extends IsiDtoHttpHandlerRequestV3 implements IIsiDtoHttpHandlerRequestV4 {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.HttpHandlers.IsiDtoHttpHandlerRequestV4`1[[Isilog.IsiFramework.IsiInterface.Dto.HttpHandlers.IIsiDtoHttpHandlerResponseV4, Isilog.IsiFramework.IsiInterface, Version=5.4.54.0, Culture=neutral, PublicKeyToken=5e9f15e67e487ab2]], Isilog.IsiFramework.IsiDataTransferObject";
    response?: IsiDtoHttpHandlerResponseV4;

    constructor(data?: IIsiDtoHttpHandlerRequestV4) {
        super(data);
        if (data) {
            this.response = data.response && !(<any>data.response).toJSON ? new IsiDtoHttpHandlerResponseV4(data.response) : <IsiDtoHttpHandlerResponseV4>this.response;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.response = _data["response"] ? IsiDtoHttpHandlerResponseV4.fromJS(_data["response"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoHttpHandlerRequestV4): IsiDtoHttpHandlerRequestV4 {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoHttpHandlerRequestV4();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["response"] = this.response != null ? (<any>this.response).toJSON() : <any>null;
        return data;
    }
}
/** Représente l'état d'un composant coté client */
export class IsiDtoComponentClientState extends IsiDataTransferObject implements IIsiDtoComponentClientState {
    $type?: string = "Isilog.IsiFramework.IsiDataTransferObject.WebGUI.Components.IsiDtoComponentClientState, Isilog.IsiFramework.IsiDataTransferObject";
    id?: string;

    constructor(data?: IIsiDtoComponentClientState) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoComponentClientState): IsiDtoComponentClientState {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoComponentClientState();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["id"] = this.id !== undefined ? this.id : <any>null;
        return data;
    }
}
